import React, { useState } from "react";
import { Group, Tag, Label, Text } from "react-konva";
import RecordIcon from "../RecordIcon";
import styles from "./styles";

const RecordName = (props) => {
  const { record, onClick } = props;

  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <Group>
      <RecordIcon
        x={record.x + 5}
        y={record.y + 10}
        entityCategory={record.entityCategory}
      />
      <Text
        x={record.x + 25}
        y={record.y + 10}
        text={(record.recordName || "").substring(0, 20)}
        wrap="none"
        align="left"
        ellipsis={true}
        fontSize={13}
        fill={"blue"}
        fontFamily={"Source Sans Pro,sans-serif"}
        onClick={onClick}
        onMouseEnter={(e) => {
          e.target.getStage().container().style.cursor = 'pointer';
          setShowTooltip(true);
        }}
        onMouseLeave={(e) => {
          e.target.getStage().container().style.cursor = 'default';
          setShowTooltip(false);
        }}
      />
      {showTooltip && <Label
        x={record.x + 35}
        y={record.y + 10}
        opacity={0.75}
        visible={showTooltip}
      >
        <Tag
          fill="#707070"
          pointerDirection="down"
          pointerWidth={10}
          pointerHeight={10}
          lineJoin='round'
          shadowColor="#707070"
          shadowBlur={10}
          shadowOffsetX={10}
          shadowOffsetY={10}
          shadowOpacity={0.5}
        />
        <Text
          text={record.recordName}
          wrap="none"
          align="left"
          fontSize={13}
          padding={5}
          fill="white"
          fontFamily={"Source Sans Pro,sans-serif"}
        />
      </Label>}

    </Group>
  )
};

export default RecordName;